<p-confirmDialog key="addjob" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="ItemBorder">
	<div class="MainItemDiv">
		<label>Job Name:</label>
		<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="JobDesc" />

		<label>Report:</label>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SelectedReportScript"
			[(ngModel)]="SelectedReportScript"
			(ngModelChange)="onSelectedReportScript($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstReportScript" [ngValue]="o">{{ o.ReportScriptDesc }}</option>
		</select>

		<div class="ParameterDiv" *ngFor="let o of SelectedReportScript?.lstParameters">
			<label>{{ o.ParameterDesc }}:</label>
			<input
				*ngIf="(o.ParameterTypeID == 1 || o.ParameterTypeID == 2 || o.ParameterTypeID == 3) && o.UseList == false"
				type="text"
				class="form-control"
				[(ngModel)]="o.ParameterValue"
			/>
			<select
				*ngIf="(o.ParameterTypeID == 1 || o.ParameterTypeID == 2 || o.ParameterTypeID == 3) && o.UseList == true"
				[disabled]="IsLoading() == true"
				class="form-control"
				name="ParameterValue"
				[(ngModel)]="o.ParameterValue"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of o.lstOptions" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>

			<p-calendar
				*ngIf="o.ParameterTypeID == 4"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
			<p-calendar
				*ngIf="o.ParameterTypeID == 5"
				showTime="true"
				timeOnly="true"
				timeFormat="12"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
			<p-calendar
				*ngIf="o.ParameterTypeID == 6"
				[showTime]="true"
				timeFormat="12"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
		</div>

		<label>Time:</label>
		<p-calendar
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="RunTime"
			name="RunTime"
			appendTo="body"
		></p-calendar>

		<label>Days:</label>
		<table class="WeekTable">
			<tr>
				<th><label for="RunMon">Monday</label></th>
				<th><label for="RunTue">Tuesday</label></th>
				<th><label for="RunWed">Wednesday</label></th>
				<th><label for="RunThu">Thursday</label></th>
				<th><label for="RunFri">Friday</label></th>
				<th><label for="RunSat">Saturday</label></th>
				<th><label for="RunSun">Sunday</label></th>
			</tr>
			<tr>
				<td><input [disabled]="IsLoading() == true" id="RunMon" type="checkbox" class="CHK" [(ngModel)]="RunMon" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunTue" type="checkbox" class="CHK" [(ngModel)]="RunTue" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunWed" type="checkbox" class="CHK" [(ngModel)]="RunWed" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunThu" type="checkbox" class="CHK" [(ngModel)]="RunThu" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunFri" type="checkbox" class="CHK" [(ngModel)]="RunFri" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunSat" type="checkbox" class="CHK" [(ngModel)]="RunSat" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunSun" type="checkbox" class="CHK" [(ngModel)]="RunSun" /></td>
			</tr>
		</table>
	</div>
</div>

<div class="ItemBorder TopMargin">
	<h4 style="text-align: center">Send To:</h4>

	<div>
		<div>
			<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAddUser()">Add</button>
			<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onRemoveUser()">Remove</button>
		</div>
		<p-table
			#mydt
			[value]="lstUsers"
			[loading]="IsLoading()"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedUsers"
			dataKey="UserID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--Username-->
					<th>
						<p-columnFilter type="text" field="Username" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffID-->
					<th>
						<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>
					<th pSortableColumn="Username">User<p-sortIcon field="Username"></p-sortIcon></th>
					<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-User>
				<tr [pSelectableRow]="User">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
					</td>
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ User[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
